import { Component, inject, InjectionToken, Type, viewChild } from '@angular/core';

import { DropdownItemComponent } from '../../../../common/dropdown/dropdown-item/dropdown-item.component';
import { IconComponent } from '../../../../common/icon/icon.component';
import { Select2Item } from '../../types';
import { Select2ListItemDirective } from './list-item.directive';

export const DEFAULT_LIST_ITEM_COMPONENT = new InjectionToken<Type<Select2DefaultItemComponent>>(
  'default list item',
);

@Component({
  selector: 'rt-select-list-item',
  imports: [Select2ListItemDirective, DropdownItemComponent, IconComponent],
  template: `
    <ng-container
      *rtSelectListItem="
        selectType;
        let selectCtrl;
        let item = item;
        let isHoverState = isHoverState;
        let index = index;
        let isLast = isLast
      "
    >
      <rt-dropdown-item
        [noDivider]="isLast"
        [class.hover]="isHoverState"
        (click)="selectCtrl.select$.next(item)"
      >
        @if (item.icon) {
          <rt-icon prefix [name]="item.icon"></rt-icon>
        }
        {{ item.label }}
        @if (selectCtrl.itemSelector.isSelected(item)) {
          <rt-icon suffix name="check" colorToken="colorIconSuccessDefault"></rt-icon>
        }
      </rt-dropdown-item>
    </ng-container>
  `,
  styleUrls: ['./list-item.component.less'],
  providers: [
    {
      provide: Select2ListItemDirective,
      useFactory: () => inject(Select2DefaultItemComponent).directive(),
    },
  ],
})
export class Select2DefaultItemComponent {
  public directive = viewChild.required(Select2ListItemDirective);
  public selectType: { items: Select2Item[] };
}
